(ns com.theplantscape.svg-generation.objects
  (:require
   [com.theplantscape.calculate.ensemble :refer [average-points]]
   [com.theplantscape.conversions.ensemble
    :refer [distance-unit points->middle]]
   [com.theplantscape.svg-generation.compat :refer [rkey transform-origin]]
   [com.theplantscape.svg-generation.filters :as f]))

(def layer-defaults {:canopy {:radius "20" :size "40" :padding "50"}
                     :sub-canopy {:radius "10" :size "20" :padding "28"}
                     :shrub {:radius "3" :size "6" :padding "8"}})
(def style-use-map? (atom #?(:cljs true :clj false)))
(def animate-enabled false)
(def style-line {:stroke "#666666" :stroke-width "10" :stroke-dasharray "1 15"
                 :stroke-linecap "square" :fill "none"})
(def style-points {:fill "#00ff00" :fill-opacity "0.60" :stroke "#444444" :stroke-width "2"})
(def style-size-p1 {:fill "#00ff00" :fill-opacity "0.60" :stroke "#008800" :stroke-width "1"})
(def style-size-p2 {:fill "#00dd00" :fill-opacity "1" :stroke "#444444" :stroke-width "1"})
(def style-size-p3 {:fill "#00bb00" :fill-opacity "1" :stroke "#444444" :stroke-width "0.25"})
(def style-size-p4 {:fill "#009900" :fill-opacity "0.60" :stroke "#444444" :stroke-width "0.15"})
(def style-size-p5 {:fill "#007700" :fill-opacity "0.60" :stroke "#444444" :stroke-width "0.05"})
(def style-size-p6 {:fill "#005500" :fill-opacity "0.60" :stroke "#444444" :stroke-width "0.05"})
(def style-size-p7 {:fill "#003300" :fill-opacity "0.60" :stroke "#444444" :stroke-width "0.05"})
(def style-area {:fill "#8B4513" :fill-opacity "0.85"})
(def style-structure {:fill "#8B4513" :fill-opacity "0.85"})
(def style-patch {:fill "#8B4513" :fill-opacity "0.85" :background-repeat "space" :stroke-dasharray "5 3" :stroke "#666666" :stroke-width "2"  :stroke-linecap "round"})
(defn set-stroke-colour [style colour] (if (empty? colour) style  (merge style {:stroke colour})))
(defn set-fill-opacity [style opacity] (if (empty? opacity) style  (merge style {:fill-opacity opacity})))
(defn set-fill-colour [style colour] (if (empty? colour) style  (merge style {:fill colour})))
(defn set-fill-pattern [style pattern-id]
  (if (empty? pattern-id) style  (merge style {:fill (str "url(#" pattern-id ")")})))
(defn set-colour [style colour] (if (empty? colour) style  (merge style {:fill colour :stroke colour})))

(defn style [m]
  (if (true? @style-use-map?)
    m
    (reduce (fn [s [k v]] (str s (name k) ":" v ";")) "" m)))

(defn points->str [points]
  (apply str (interpose " " (flatten points))))

(defn points->str-1 [points]
  (apply str (map #(str " T " (points->str %)) points)))

(defn info-scaled
  ([x y label] (info-scaled x y label "1.0"))
  ([x y label scale]
   ;; TODO batik has issues with transform
   [:g
    {:text-anchor "middle"
     :transform (str "matrix(" scale ",0,0," scale "," (* x (- 1 scale)) "," (* y (- 1 scale)) ")")
     ;;:transform (str "scale(" scale ", " scale ") translate(-50%,-50%)")
     ;;:transform (str "translate(-50%,-50%)")
     }
    [:text
     {:x x :y y
      :font-size "6px"
      :style (style {:text-anchor "middle" :stroke "red" :stroke-width "0px"
                     :dominant-baseline "middle"
                     :alignment-baseline "middle"})} label]]))

(defn info [x y label]
  [:g
   [:text.text-10
    {:x x :y y
     :font-size "6px"
     :style (style {:text-anchor "middle" :stroke "red" :stroke-width "0px"
                    :dominant-baseline "middle"
                    :alignment-baseline "middle"})} label]])

(defn ruler
  ([[x1 y1] [x2 y2]] (ruler [x1 y1] [x2 y2] :cm))
  ([[x1 y1] [x2 y2] units] (ruler [x1 y1] [x2 y2] :cm 5))
  ([[x1 y1] [x2 y2] units scale]
   (let [[x y] (points->middle [x1 y1] [x2 y2])]
     [:g
      [:g
       (-> {:transform (str "scale(" scale ", " scale ")")
            :style {:transform-box "fill-box"}}
           (transform-origin (str "50% 50%") #_(str x " " y)))
       [:rect {:x (+ x1 5) :y (- y1 24) :rx 5 :width 90 :height 24 :fill "#000000"
               :style (style {:dominant-baseline "middle"})}]
       [:text.text-sm {:x (+ x1 50) :y (- y1 12)
                       :style (style {:text-anchor "middle"
                                      :fill "#ffffff" :stroke "#ff0000" :stroke-width "0px"
                                      :dominant-baseline "middle"
                                      :alignment-baseline "middle"})}
        (str (distance-unit [x1 y1] [x2 y2] units) " " units)]]
      [:line {:x1 x1 :y1 y1 :x2 x2 :y2 y2
              :style (style {:stroke-width (str scale) :stroke "#ff000055"
                             :stroke-dasharray (str scale " " scale) #_"4 1"})}]])))

(defn marker-event [e]
  (.preventDefault e))

(defn marker [{:keys [entity-id plant-entity-id label colour points svg-filter radius] :or {colour "#ff0000ff"} :as marker}]
  [:g (rkey entity-id)
   [:g#marker-group {:on-pointer-up marker-event
                     :on-pointer-down marker-event
                     :on-pointer-move marker-event
                     :transform (str "translate(" (first points) " " (second points) ")") #_"matrix(0.6,0,0,0.6,0,0)"}
    [:path#marker-path
     {:style {:fill "#803300" :fill-opacity "0.798051" :stroke "#000000" :stroke-width "1.265"}
      :d "M 10.294802,-22.014962 C 10.294802,-16.469721 6.477309,-11.219028 0,0 c -6.587275,-11.409495 -10.294803,-16.469721 -10.294803,-22.014962 0,-5.545241 4.60914,-10.040547 10.294803,-10.040547 5.685662,10e-7 10.294802,4.495306 10.294802,10.040547 z"}]
    [:circle#marker-circle {:style {:fill "#aa8800" :fill-opacity "0.869079" :stroke "#000000" :stroke-width "1.265"}
                            :cx "0"
                            :cy "-22.014962"
                            :r "5.0108876"}]]])

(defn point
  ([xy] (point 9999 xy "5"))
  ([eid xy] (point eid xy "5"))
  ([eid [x y] r]
   [:g (rkey eid)
    [:circle {:cx x
              :cy y :r (str (or r "5"))
              :style (style {:fill "#0000ffff" :opacity "0.5"})}
     (when animate-enabled
       [:animate {:attribute-name "r"
                  :values (str r #_(or r "5") ";" (str (/ r 2)) ";" r #_(str (or r "5") ";2;5"))
                  :dur "2s" :repeat-count "indefinite"}])]]))

(defn points
  ([xy] (points 9999 xy))
  ([eid xy]
   (if (vector? (first xy))
     [:g (map-indexed (fn [idx pos]
                        [:g (rkey idx) (point idx pos)]) xy)]
     (point eid xy))))

(defn unknown
  "Default or unknown object"
  [{:keys [entity-id plant-entity-id label colour points svg-filter] :as object}]
  [:g.unknown (rkey entity-id)
   [:circle {:cx (-> points first first)
             :cy (-> points first second)
             :r "5"
             :aria-labelledby (str "t-" entity-id)
             :filter (str "url(#" (or svg-filter "tree-filter")  ")")
             :style (-> style-size-p1
                        (set-fill-opacity "1.0")
                        (set-colour colour)
                        (style))}
    (str points)
    [:title {:id (str "t-" entity-id)} label]]
   (info (-> points first first) (-> points first second)  plant-entity-id)])

(defn canopy-tree [{:keys [entity-id plant-entity-id label colour points svg-filter] :as tree}]
  (tap> tree)
  [:g.canopy-tree (rkey entity-id)
   [:circle {:cx (-> points first first)
             :cy (-> points first second)
             :r "20"
             :aria-labelledby (str "t-" entity-id)
             :filter (str "url(#" (or svg-filter "tree-filter")  ")")
             :style (-> style-size-p1
                        (set-fill-opacity "1.0")
                        (set-colour colour)
                        (style))}
    ;;(str points)
    [:title {:id (str "t-" entity-id)} label]]
   (info (-> points first first) (-> points first second)  plant-entity-id)])

(defn sub-canopy-tree [{:keys [entity-id plant-entity-id label colour points svg-filter]}]
  [:g.sub-canopy-tree (rkey entity-id)
   [:circle {:cx (-> points first first)
             :cy (-> points first second)
             :r "10"
             :filter (str "url(#" (or  "tree-filter" svg-filter)  ")")
             :style (style style-size-p2 #_(set-colour style-size-p2 colour))}]
   (info (-> points first first) (-> points first second) plant-entity-id)])

(defn patch [{:keys [entity-id plant-entity-id colour points label svg-filter svg-fill] :as patch}]
  (prn "patch")
  (prn (str "url(#" svg-filter ")"))
  (prn patch)
  [:g.patch (rkey entity-id)
   [:polygon.patch
    {:points (points->str points)
     :data-test (str plant-entity-id)
     ;:fill (when svg-filter (str "url(#pat-"  (:plant patch) ")"))
     :style (-> style-patch
                (set-fill-pattern
                 (if svg-filter
                   (str "pat-" svg-filter)
                   "svg-pattern-4"))
                style)}]
   (when label
     (let [p (average-points points)]
       (info (first p) (second p) label)))])

(defn structure [{:keys [entity-id colour points label svg-filter]}]
  [:g.structure (rkey entity-id)
   [:polygon.structure {:points (points->str points)
                        :filter (str "url(#" (or svg-filter "hatch-filter")  ")")
                        :style (-> style-structure
                                   (set-colour colour)
                                   style)}]
   (when label
     (let [p (average-points points)]
       (info (first p) (second p) label)))])

(defn bush [{:keys [entity-id plant-entity-id colour points]}]
  [:g.bush (rkey entity-id)
   [:circle {:cx (-> points first first)
             :cy (-> points first second) :r
             "3"
             :filter "url(#bush-filter)"
             :style (-> style-size-p3
                        (set-colour colour)
                        style)}]
   (info-scaled (-> points first first) (-> points first second) plant-entity-id 0.30)])

(defn herbaceous [{:keys [entity-id plant-entity-id colour points]}]
  [:g.herbaceous (rkey entity-id)
   [:circle {:cx (-> points first first)  :cy (-> points first second)  :r "1"
             :filter "url(#bush-filter)"
             :style (-> style-size-p4
                        (set-colour colour)
                        style)}]
   (info-scaled (-> points first first) (-> points first second) plant-entity-id 0.25)])

(defn ground [{:keys [entity-id plant-entity-id colour points]}]
  [:g.ground (rkey entity-id)
   [:circle {:cx (-> points first first) :cy (-> points first second) :r "1.25"
             :filter "url(#ground-filter)"
             :style (-> style-size-p5
                        (set-colour colour)
                        style) #_(style style-size-p5)}]
   (info-scaled  (-> points first first) (-> points first second) plant-entity-id 0.15)])

(defn root [{:keys [entity-id plant-entity-id colour points]}]
  [:g.root (rkey entity-id)
   [:circle {:cx (-> points first first) :cy (-> points first second) :r "0.5"
             :filter "url(#ground-filter)"
             :style (-> style-size-p6
                        (set-colour colour)
                        style)}]
   (info-scaled (-> points first first) (-> points first second)  plant-entity-id
                0.5)])

(defn vine [{:keys [entity-id plant-entity-id colour points]}]
  [:g.vine (rkey entity-id)
   [:circle {:cx (-> points first first)
             :cy (-> points first second) :r "2"
             :filter "url(#ground-filter)"
             :style (-> style-size-p7
                        (set-colour colour)
                        style)}]
   (info-scaled (-> points first first) (-> points first second) plant-entity-id 0.25)])

(defn area [{:keys [entity-id colour points label svg-filter]}]
  [:g.area (rkey entity-id)
   [:polygon.area {:points (points->str points)
                   :filter (str "url(#" (or svg-filter "hatch-filter")  ")")
                   :style (-> {:stroke "#000000ff"
                               :stroke-width "0"
                               :stroke-linecap "round"
                               :fill "#777777ff"}
                              (set-colour  colour)
                              style)}]
   (when label
     (let [p (average-points points)]
       (info-scaled (first p) (second p) label)))])

(defn select-polyculture-plant [plant]
  (case (keyword (:layer-type plant))
    :canopy (canopy-tree (merge plant {:svg-filter "tree-filter"}))
    :sub-canopy (sub-canopy-tree (merge plant {:svg-filter "leaf-filter"}))
    :shrub (bush (merge plant {:svg-filter "bush-filter"}))
    :herbaceous (herbaceous (merge plant {:svg-filter "leaf-filter"}))
    :vine (vine (merge plant {:svg-filter "leaf-filter"}))
    :ground (ground (merge plant {:svg-filter "ground-filter"}))
    (canopy-tree (merge plant {:svg-filter "tree-filter"}))))

(defn polyculture [plants]
  (-> [:g#polyculture]
      (conj f/filters)
      (conj (into [:g#diagram] (mapv select-polyculture-plant plants))))
  #_(into [:g#polyculture]
          #_[f/filters]
          (mapv select-polyculture-plant plants)))

(defn svg-no-events [width height group]
  [:svg#diagram
   {:width width :height height
    :version "1.1"
    :xmlns "http://www.w3.org/2000/svg"
    :style (style {:pointer-events "none"})}
   group])

(defn svg-image [width height group]
  [:svg#diagram
   {:width width :height height
    :version "1.1"
    :xmlns "http://www.w3.org/2000/svg"
    :style (style {:pointer-events "none"})}
   group])

(defn boundary [{:keys [:diagram.settings/height :diagram.settings/width] :as b}]
  [:rect #?(:cljs {:x (* -1 (/ (js/parseInt (or width "100")) 2))
                   :y (* -1 (/ (js/parseInt (or height "100")) 2))
                   :width (str  (or width "100") "px")
                   :height (str  (or height "100") "px")
                   :style (style {:fill "#aaffaa"})}
            :clj {:x (* -1 (/ (Integer/parseInt (or width "100")) 2))
                  :y (* -1 (/ (Integer/parseInt (or height "100")) 2))
                  :width (str  (or width "100") "px")
                  :height (str  (or height "100") "px")
                  :style (style {:fill "#aaffaa"})})])

(defn zoom
  ([size grow-cb shrink-cb] (zoom :vertical size grow-cb shrink-cb))
  ([direction size grow-cb shrink-cb]
   (let [half (/ size 2)
         x (if (= direction :vertical) size 0)
         y (if (= direction :vertical) 0 size)
         width (str (if (= direction :vertical) (* size 2) size))
         height (str (if (= direction :vertical) size (* size 2)))]
     (fn [direction size grow-cb shrink-cb]
       [:svg#control
        {:x 10 :y 10
         :height height
         :width width
         :on-mouse-move #(.stopPropagation %)
         :version "1.1"
         :xmlns "http://www.w3.org/2000/svg"}
        [:rect {:on-click grow-cb :width (str size) :height (str size)  :x 0 :y 0 :stroke-width "2" :fill "white" :stroke "black"  :fill-opacity "1"}]
        [:text.small {:on-click grow-cb :font-size size :x (str half) :y (str half) :dominant-baseline "middle" :text-anchor "middle"} "+"]
        [:rect {:on-click shrink-cb :x x :y y :width (str size) :height (str size)   :stroke-width "2" :stroke "black" :fill "white"  :fill-opacity "1"}]
        [:text {:on-click shrink-cb :font-size size :x (str (+ x half)) :y (str (+ y half)) :dominant-baseline "middle" :text-anchor "middle"} "-"]]))))

(defn compass [size rotation active]
  (let [half (/ size 2)
        needle-thickness 7
        offset 15
        offset-max (- size 20)
        colour (if active "red" "black")]
    (fn [size rotation active]
      [:svg#compass
       {:x 5 :y 5 :style (style {:pointer-events "none"}) :xmlns "http://www.w3.org/2000/svg" :width size :height size}
       [:circle {:cx (str half) :cy (str half)
                 :r (- half 5) :stroke-width "5" :stroke (if active "red" "grey")  :fill-opacity "0.1" :fill "grey"}]

       [:polygon.triangle {:points (str half "," offset-max " " (- half needle-thickness) " , " half " " half "," offset " " (+ half needle-thickness) "," half)
                           :fill (if active "red" "black")
                           :transform (str "rotate(" rotation " " half " " half ")")}]
       [:circle {:cx (str half) :cy (str half) :r "5" :stroke-width "5" :fill "white"  :fill-opacity "1"}]

       [:text.text-xs {:x (str half) :y (str offset) :dominant-baseline "middle" :text-anchor "middle"} "N"]
       [:text.text-xs {:x (str half) :y (str (- size offset))  :dominant-baseline "middle" :text-anchor "middle"} "S"]
       [:text.text-xs {:x (str offset) :y (str half)  :dominant-baseline "middle" :text-anchor "middle"} "W"]
       [:text.text-xs {:x (str (- size offset)) :y (str half)  :dominant-baseline "middle" :text-anchor "middle"} "E"]])))

(defn path
  "butt, round, square for line caps"
  [{:keys [entity-id plant-entity-id colour points]}]
  (prn (str "M " (points->str points)
            " Q " (points->str (first (drop 1 points)))
            ", " (points->str (first (drop 2 points)))
            (points->str-1 (drop 3 points))))
  [:g (rkey entity-id)
   [:path {:d (str "M " (points->str (take 1 points))
                   " Q " (points->str (first (drop 1 points)))
                   ", " (points->str (first (drop 2 points)))
                   (points->str-1 (drop 3 points)))
           :style (style style-line)}]])

(defn build-pattern-layer [layer plant]
  (let [settings {:plant-id ""}]
    (case layer
      :canopy (canopy-tree settings))))

(defn svg-build-pattern [pat-name svg-shape]
  (prn "build pattern")
  (prn svg-shape)
  (let [layer-key (keyword (:svg-filter svg-shape))]
    (prn layer-key)
    [:pattern
     {:key (str "pat-" pat-name)
      :id (str "pat-" pat-name) :x "0" :y "0"
      :style {:overflow "visible"}
      :width (get-in layer-defaults [layer-key :size] "10")
      :height (get-in layer-defaults [layer-key :size] "10")
      :view-box (str "0 0 " (get-in layer-defaults [layer-key :padding] "50") " "
                     (get-in layer-defaults [layer-key :padding] "50"))
      :patternUnits "userSpaceOnUse"}
     (prn (:svg-filter svg-shape))
     (case layer-key
       :canopy
       (canopy-tree
        (merge
         svg-shape
         {:points [[(-> layer-defaults :canopy :radius)
                    (-> layer-defaults :canopy :radius)]]}))
       :sub-canopy
       (sub-canopy-tree
        (merge svg-shape {:points [[(-> layer-defaults :canopy :radius)
                                    (-> layer-defaults :canopy :radius)]]}))

       :shrub
       (bush
        (merge svg-shape {:points [[(-> layer-defaults :shrub :radius)
                                    (-> layer-defaults :shrub :radius)]]}))

       (canopy-tree
        (merge
         svg-shape
         {:points [[(-> layer-defaults :canopy :radius)
                    (-> layer-defaults :canopy :radius)]]})))]))

(defn svg-pattern-canopy [area]
  (prn "patterns")
  (prn area)
  (prn (str (:plant/common-name area)))
  (svg-build-pattern
   (str (name (:plant/type area))) #_"test"
   #_(str (:plant-entity-id area)) #_"test"
   area
   #_(canopy-tree (merge area {:points [["20" "20"]]}))))

(defn area-patterns [areas]
  (prn "area patterns")
  (prn areas)
  (mapv svg-pattern-canopy areas))
